module.exports = __webpack_public_path__ + "static/img/certificate2.7ba8513.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate2.jpg
// module id = n9+Q
// module chunks = 1